import React from 'react';
import { Heading } from 'src/components/Form';
import LoadState from 'src/components/LoadState/LoadState';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import {
  useSystemLevelNotifications,
  SystemLevelNotification,
  NotificationChannel,
  UseSystemLevelNotificationsReturn,
} from 'src/pages/Settings/CustomHooks/useSystemNotifications';
import SystemNotificationRow from './SystemNotificationRow';
import './SystemLevelNotificationSection.scss';
import '../../Settings.scss';

const DESCRIPTION = `Control which notifications Juniper sends below. Each notification can be switched on or off separately for internal and external users. Internal users are your organisation's team who manage properties — property developers, strata / property managers and service managers. External users are the people they serve — homeowners, occupants and service providers. Turning a notification off applies to every user of that type.`;

const SystemLevelNotificationsSection: React.FC = () => {
  const {
    notifications,
    isLoading,
    isSubmitting,
    hasChanges,
    canAccessSystemNotifications,
    toggleChannel,
    submitChanges,
  }: UseSystemLevelNotificationsReturn = useSystemLevelNotifications();

  if (!canAccessSystemNotifications) {
    return null;
  }

  return (
    <div className="settingsSection">
      <Heading>System Level Notifications</Heading>
      <p className="settingsDescription">{DESCRIPTION}</p>
      <LoadState isLoading={isLoading}>
        {notifications.map((notification: SystemLevelNotification) => (
          <SystemNotificationRow
            key={notification.id}
            notification={notification}
            onToggleChannel={(channel: NotificationChannel) =>
              toggleChannel(notification.id, channel)
            }
          />
        ))}

        <div className="system-notifications-actions">
          <LoadingButton
            actionText="Submit permission changes"
            isSubmitting={isSubmitting}
            disabled={!hasChanges}
            onClick={submitChanges}
          />
        </div>
      </LoadState>
    </div>
  );
};

export default SystemLevelNotificationsSection;
